import { render, staticRenderFns } from "./kiosk-dashboard.vue?vue&type=template&id=45c6d176&"
import script from "./kiosk-dashboard.vue?vue&type=script&lang=js&"
export * from "./kiosk-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./kiosk-dashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports